<div class="sh-fixed-header-panel">
    <section class="sh-fixed-header-panel__head">
        <div class="sh-fixed-header-panel__head__title">
            <ng-content select="[title]"></ng-content>
        </div>
        <ng-content select="[head]"></ng-content>
    </section>
    <section class="sh-fixed-header-panel__content">
        <ng-content select="[body]"></ng-content>
    </section>
</div>
